import React, { useEffect, useMemo, useRef, useState } from "react";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import FlightItem from "./FlightItem";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

import AddIcon from "@mui/icons-material/Add";
import { useDisclosure } from "@mantine/hooks";
import { Controller, useForm } from "react-hook-form";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import axios from "axios";
import base_url from "../../api/bootapi";
import PhoneInput from "react-phone-number-input";
import { Loader, Menu, Modal } from "@mantine/core";

import RemoveIcon from "@mui/icons-material/Remove";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import moment from "moment";

const FlightDetails = ({
  flightDetailsData,
  fromAirport,
  toAirport,
  flightClassType,
  tripType,
  adults,
  children,
  InfantsInSeat,
  InfantsOnLap,
  handleMinus,
  handlePlus,
  setFlightDetailsData,
  setShowDetails,
}) => {
  const [totalTravellers, setTotalTravellers] = useState(0);
  const [opened, { open, close }] = useDisclosure(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    const total = adults + children + InfantsInSeat + InfantsOnLap;
    setTotalTravellers(total);
  }, [adults, children, InfantsInSeat, InfantsOnLap]);

  const formatFlightTime = (dateTime) => {
  // Block null, undefined, empty string, non-string
  if (!dateTime || typeof dateTime !== "string") return "";

  const m = moment(dateTime, "YYYY-MM-DD HH:mm", true);

  return m.isValid()
    ? m.format("MM/DD/YYYY HH:mm")
    : "";
};

  const onSubmit = async (data) => {
    setLoadingRequest(true);
    setIsSuccess(false);
    const personalDetails = data;
    personalDetails.adults = adults;
    personalDetails.children = children;
    personalDetails.infants_in_seat = InfantsInSeat;
    personalDetails.infants_on_lap = InfantsOnLap;
    personalDetails.travelers =
      adults + children + InfantsInSeat + InfantsOnLap;

    console.log(flightDetailsData)

    const formattedData = flightDetailsData.map(item => ({
  ...item,
  flights: item.flights.map(flight => ({
    ...flight,
    departure_airport: {
      ...flight.departure_airport,
      time: formatFlightTime(flight?.departure_airport?.time),
    },
    arrival_airport: {
      ...flight.arrival_airport,
      time: formatFlightTime(flight?.arrival_airport?.time),
    },
  })),
}));
    let requestData = {};
    requestData.enquiryFlights = formattedData;

    requestData.person = personalDetails;

    const totalPrice = flightDetailsData.reduce((sum, item) => {
      const price = item.price ?? 0;
      return sum + price;
    }, 0);

    requestData.price = totalPrice;

    try {
      const response = await axios.post(
        `${base_url.api1}/users/save_booking_enquiry`,
        requestData
      );
      console.log(response.data);

      setLoadingRequest(false);
      reset();
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setIsSuccess(false);
    }
  };

  const handleGoBack = () => {
    setFlightDetailsData((prev) => prev.slice(0, -1));
    setShowDetails(false);
  };

  return (
    <div
      className="flight_search_wrapper mobile_search-wrapper"
      style={{ marginTop: "50px" }}
    >
      <Modal
        opened={opened}
        onClose={() => {
          close();
          setIsSuccess(false);
        }}
        closeOnClickOutside={false}
      >
        <div>
          {isSuccess ? (
            <div className="thank-you-wrapper">
              <TaskAltIcon sx={{ fontSize: "70px", color: "green" }} />

              <h3>Submitted successfully! </h3>

              <span>
                Thanks for submitting your request, a Linsoa rep will reach out
                to you soon
              </span>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit(onSubmit)}
              style={{ maxWidth: 400, margin: "auto" }}
            >
              <div className="submit-request-input-wrapper">
                <label>
                  Full Name<span>*</span>
                </label>
                <input
                  {...register("name", { required: "Name is required" })}
                  // placeholder="Name"
                />
                {errors.name && <p>{errors.name.message}</p>}
              </div>

              <div className="submit-request-input-wrapper">
                <label>
                  Mobile Number<span>*</span>
                </label>
                <Controller
                  name="mobile"
                  control={control}
                  rules={{
                    required: "Mobile number is required",
                    validate: (value) =>
                      value && value.length >= 10
                        ? true
                        : "Invalid mobile number",
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      international
                      defaultCountry="US"
                      // placeholder="Enter phone number"
                    />
                  )}
                />
                {errors.mobile && <p>{errors.mobile.message}</p>}
              </div>

              <div className="submit-request-input-wrapper">
                <label>
                  Email Address<span>*</span>
                </label>
                <input
                  type="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Invalid email address",
                    },
                  })}
                  // placeholder="example@mail.com"
                />
                {errors.email && <p>{errors.email.message}</p>}
              </div>

              <div className="submit-request-input-wrapper">
                <label>
                  Number of Travellers<span>*</span>
                </label>
                <Menu
                  shadow="md"
                  position="bottom-start"
                  offset={2}
                  width={250}
                  closeOnItemClick={false}
                >
                  <Menu.Target>
                    <input
                      type="number"
                      {...register("travelers", {
                        required: "Please enter number of travellers",
                        min: {
                          value: 1,
                          message: "At least 1 traveller required",
                        },
                      })}
                      value={totalTravellers}
                      readOnly

                      // placeholder="Travellers"
                    />
                  </Menu.Target>

                  <Menu.Dropdown>
                    <div className="person-wrapper">
                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Adults</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={adults === 1}
                            style={{ opacity: adults === 1 ? 0.6 : 1 }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleMinus("adults");
                            }}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{adults}</span>
                          <button
                            className="count-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handlePlus("adults");
                            }}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>

                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Children</span>
                          <span className="person-sub">Aged 2-11</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={children === 0}
                            style={{ opacity: children === 0 ? 0.6 : 1 }}
                            onClick={() => handleMinus("children")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{children}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("children")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>

                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Infants</span>
                          <span className="person-sub">In seat</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={InfantsInSeat === 0}
                            style={{ opacity: InfantsInSeat === 0 ? 0.6 : 1 }}
                            onClick={() => handleMinus("InfantsInSeat")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{InfantsInSeat}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("InfantsInSeat")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>

                      <div className="person-item">
                        <div className="person-category">
                          <span className="person-main">Infants</span>
                          <span className="person-sub">On lap</span>
                        </div>
                        <div className="count-wrapper">
                          <button
                            className="count-btn"
                            disabled={InfantsOnLap === 0}
                            style={{ opacity: InfantsOnLap === 0 ? 0.6 : 1 }}
                            onClick={() => handleMinus("InfantsOnLap")}
                          >
                            <RemoveIcon />
                          </button>
                          <span className="count-value">{InfantsOnLap}</span>
                          <button
                            className="count-btn"
                            onClick={() => handlePlus("InfantsOnLap")}
                          >
                            <AddIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </Menu.Dropdown>
                </Menu>
              </div>

              <button
                type="submit"
                className="modal-submit-btn"
                disabled={loadingRequest}
              >
                {loadingRequest ? (
                  <Loader color="#fff" size={"sm"} />
                ) : (
                  "Submit request"
                )}
              </button>
            </form>
          )}
        </div>
      </Modal>
      <div className="new-flight-details-wrapper">
        <span className="back-btn" onClick={handleGoBack}>
          <KeyboardBackspaceOutlinedIcon sx={{ fontSize: "40px" }} />
        </span>
        <div className="flight-details-left">
          <div className="details-airport-names">
            {tripType === "multi-city" && <span>Multi-city trip</span>}

            {tripType !== "multi-city" && (
              <>
                {" "}
                <span>{fromAirport.municipalityName}</span>
                {tripType === "round-trip" && <SwapHorizOutlinedIcon />}
                {tripType === "one-way" && (
                  <ArrowForwardOutlinedIcon sx={{ fontSize: "19px" }} />
                )}{" "}
                <span>{toAirport.municipalityName}</span>
              </>
            )}
          </div>
          <div className="details-features">
            <span>
              {tripType === "round-trip"
                ? "Round trip"
                : tripType === "one-way"
                ? "One way"
                : tripType === "multi-city"
                ? "Multi city"
                : ""}
            </span>{" "}
            . <span>{flightClassType}</span> .{" "}
            <span>
              <PeopleOutlineOutlinedIcon sx={{ fontSize: "18px" }} />{" "}
              {adults + children + InfantsInSeat + InfantsOnLap}
            </span>
          </div>
        </div>

        <div className="new-flight-details-right">
          <button className="submit-enquiry-btn" onClick={open}>
            <EmailOutlinedIcon /> Submit request
          </button>
        </div>
      </div>

      <div className="selected-flights-wrapper">
        <h3>Selected Flights</h3>

        <div className="details-flight-list">
          {flightDetailsData &&
            flightDetailsData.length > 0 &&
            flightDetailsData.map((flight, index) => {
              return (
                <FlightItem
                  flight={flight}
                  key={index}
                  expand={true}
                  hideSelectBtn={true}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default FlightDetails;
